import { render } from "./NcrmContactNormalizationWorkflowDetail.vue?vue&type=template&id=1d2f9ebc&scoped=true"
import script from "./NcrmContactNormalizationWorkflowDetail.vue?vue&type=script&lang=js"
export * from "./NcrmContactNormalizationWorkflowDetail.vue?vue&type=script&lang=js"

import "./NcrmWorkflowDetail.css?vue&type=style&index=0&id=1d2f9ebc&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2f9ebc"]])

export default __exports__